import { InputLabel } from '@mui/material';
import MuiPhoneNumber from 'material-ui-phone-number';
import type { FC } from 'react';
import React, { useState } from 'react';

interface PhoneNumberFieldProps {
  labelText?: string;
  placeholder?: string;
  defaultCountry?: string | undefined;
  onChange: (value: any) => void;
  maxWidth?: string;
  value?: any;
  variant?: 'outlined' | 'filled' | 'standard';
  fullWidth?: boolean;
  error?: boolean;
  helperText?: any;
  className?: string;
}

const PhoneNumberField: FC<PhoneNumberFieldProps> = ({
  labelText,
  placeholder,
  error,
  defaultCountry = 'de',
  onChange,
  className,
  value,
  maxWidth,
  variant = 'outlined',
  fullWidth = true,
  InputProps = {},
  helperText,
}: any) => {
  const [isValid, setIsValid] = useState<any>(true);
  const validatePhoneNumber = (val: any) => {
    // if (val.length > 3 && val.length < 12) {
    //   setPhoneNumber('Phone number should be atleast 8 numbers');
    // } else if (val.length > 15) {
    //   setPhoneNumber('Phone number cannot be longer than 10 numbers');
    // } else {
    //   setPhoneNumber('');
    // }
    // return val;
  };
  const handleChange: any = (event: any, countryDetails: any) => {
    const { dialCode }: any = countryDetails;
    const phoneNumber =
      event?.replaceAll(/[^0-9]/g, '')?.replace(dialCode, '') || null;
    console.log('main');
    console.log(dialCode);
    console.log(phoneNumber);

    onChange({
      country_code: `+${dialCode}`,
      phone: `+${dialCode}${phoneNumber}`,
    });
  };

  return (
    <>
      <InputLabel
        shrink
        variant="standard"
        className="!transform-none pb-1.5 !text-sm !font-medium not-italic text-secondary-200"
      >
        {labelText}
      </InputLabel>
      <MuiPhoneNumber
        placeholder={placeholder}
        data-cy="user-phone"
        defaultCountry={defaultCountry}
        value={value}
        onChange={handleChange}
        fullWidth={fullWidth}
        variant={variant}
        maxRows={10}
        // InputProps={InputProps}
        error={Boolean(error)}
        // helperText={helperText}
        sx={{ '& svg': { height: '1em' } }}
      />
      {Boolean(error) && (
        <span className="ml-0 text-xs text-error-500">{helperText || ' '}</span>
      )}
      {/* {phoneNumber && (
          <span>
            <p className="text-xs font-normal text-error-500">{phoneNumber}</p>
          </span>
        )} */}
    </>
  );
};
PhoneNumberField.displayName = 'PhoneNumberField';
PhoneNumberField.defaultProps = {
  error: false,
  helperText: '',
  className: '',
};
export default PhoneNumberField;
